module.exports = "/images/1280px-Vattenfall_logo2.png?ad8e1b1d206825bd9c1d0f9f0dafaa93";